<template>
  <el-dialog :visible.sync="visible" title="输入电票邮箱地址" :close-on-click-modal="false" width="600px" @close="handleClose">
    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
      <el-form-item label="邮箱地址1" prop="email1">
        <el-autocomplete
          v-model="form.email1"
          clearable
          placeholder="请输入邮箱地址1"
          :fetch-suggestions="queryEmail"
          @select="(item) => handleSelect('email1', item)"
        >
          <template slot-scope="{ item }">
            <div class="name">
              {{ item.value }}
            </div>
          </template>
        </el-autocomplete>
      </el-form-item>

      <el-form-item label="邮箱地址2" prop="email2">
        <el-autocomplete
          v-model="form.email2"
          clearable
          placeholder="请输入邮箱地址2"
          :fetch-suggestions="queryEmail"
          @select="(item) => handleSelect('email2', item)"
        >
          <template slot-scope="{ item }">
            <div class="name">
              {{ item.value }}
            </div>
          </template>
        </el-autocomplete>
      </el-form-item>

      <el-form-item label="邮箱地址3" prop="email3">
        <el-autocomplete
          v-model="form.email3"
          clearable
          placeholder="请输入邮箱地址3"
          :fetch-suggestions="queryEmail"
          @select="(item) => handleSelect('email3', item)"
        >
          <template slot-scope="{ item }">
            <div class="name">
              {{ item.value }}
            </div>
          </template>
        </el-autocomplete>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getInvoiceEmailMailList } from '@/API/index.js';
export default {
  props: {
    visible: {
      type: Boolean,
      required: false
    }
  },
  data () {
    const validateEmail = (rule, value, callback) => {
      const emailPattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
      if (value && !emailPattern.test(value)) {
        return callback(new Error('请输入有效的邮箱地址'));
      }
      callback();
    };

    return {
      form: {
        email1: '',
        email2: '',
        email3: ''
      },
      rules: {
        email1: [{ validator: validateEmail, trigger: 'blur' }],
        email2: [{ validator: validateEmail, trigger: 'blur' }],
        email3: [{ validator: validateEmail, trigger: 'blur' }]
      }
    };
  },
  methods: {
    handleSubmit () {
      const filledFields = Object.values(this.form).filter(email => email);
      const keysString = filledFields.join(';');
      this.$refs.form.validate(valid => {
        if (valid) {
          if (filledFields.length > 0) {
            this.$emit('submit', { form: this.form, keysString });
          } else {
            console.log('至少填写一个邮箱地址');
            this.$message.error('至少填写一个邮箱地址');
          }
        } else {
          console.log('表单验证失败');
          return false;
        }
      });
    },
    handleClose () {
      this.$refs.form.resetFields();
      this.$emit('update:visible', false);
    },
    setEditEmailData (data) {
      const emails = data.split(';');
      this.form.email1 = emails[0] || '';
      this.form.email2 = emails[1] || '';
      this.form.email3 = emails[2] || '';
    },

    queryEmail (queryString, cb) {
      let params = { agentId: this.$store.state.user.userId };
      getInvoiceEmailMailList(params).then((res) => {
        let { status, data } = res.data;
        if (status === '200') {
          let array = data.map(v => ({ value: v }));
          cb(array);
        }
      });
    },

    handleSelect (key, item) {
      this.form[key] = item.value;
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>
